import { gql } from '@apollo/client';

export class PushNotificationGQLFunction {
  static GET_ALL_PUSH_NOTIFICATION = gql`
    query getAllPushNotification($page: Int!, $rowsPerPage: Int!) {
      pushNotifications: allPushNotifications(page: $page, rowsPerPage: $rowsPerPage) {
        pushNotifications {
          id
          timeSend
          users {
            username
          }
          subject
          content
        }
        len
      }
    }
  `;

  static GET_PUSH_NOTIFICATION_INFO = gql`
    query getPushNotificationInfo($id: String!) {
      pushNotification: pushNotificationInfo(id: $id) {
        id
        timeSend
        users {
          username
        }
        subject
        content
      }
    }
  `;

  static SEND_PUSH_TO_ALL_USERS = gql`
    mutation sendPushToAll($subject: String!, $content: String!) {
      sendPushNotificationToAll(subject: $subject, content: $content)
    }
  `;

  static SEND_PUSH_TO_USERS = gql`
    mutation sendPushToUsers($users: [String!]!, $subject: String!, $content: String!) {
      sendPushNotificationToUsers(users: $users, subject: $subject, content: $content)
    }
  `;

  static SEND_PUSH_TO_PUSH_ID = gql`
    mutation sendPushToPushIds($pushIds: [String!]!, $subject: String!, $content: String!) {
      sendPushNotificationToPushIds(pushIds: $pushIds, subject: $subject, content: $content)
    }
  `;
}
